import React from "react";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps, typography, TypographyProps } from "styled-system";

const ThWrapper = styled.th`
  ${typography};
  ${space};
  ${layout};
  height: 100%;
  white-space: nowrap;
`;

export const Th: React.FC<TypographyProps & SpaceProps & LayoutProps> = ({ children, ...props }) => (
  <ThWrapper {...props}>{children}</ThWrapper>
);
